// extracted by mini-css-extract-plugin
export default {"page":"style_page__9OXCv","header":"style_header__PV0Ug","background":"style_background__-sQkE","workspace":"style_workspace__SHquo","window":"style_window__2cR4x"};